// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2Y6XR","column":"style_column__1W3tv","row":"style_row__2OvQH"};